module.exports = __webpack_public_path__ + "assets/img/zap@1,5x.b74fe4b9.svg";